export const Local = {
  TERMINOLOGY: "terminology",
  PERMISSION: "permission"
};
